/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React, { useState, useEffect, Fragment } from 'react';
import { MessageBar, MessageBarType, PrimaryButton, Spinner, SpinnerSize } from '@fluentui/react';
import { TextField,  } from '@fluentui/react';
import { AUTH_CONFIG } from './auth0-variables';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import TwoSidedLayout from '../components/TwoSidedLayout';
import { updateUserProfile, setAppState, toggleTheme } from '../actions'
import Cookies from 'universal-cookie';
import { useHistory, Link } from "react-router-dom";
import { isMobile } from 'react-device-detect';
import { setAuthTokens } from './tokenManager';

const error = (e) => css`
    .ms-TextField-fieldGroup {
        border-color: ${e ? '#ff1f1f' : '#D5DBE4'};
    }
    .ms-TextField-errorMessage{
    color:#ff1f1f;
        padding-top: 0;
    }
    `;


const warning = () => css`
    display: flex;
    align-items: flex-start;
    background: #fef0f1;
    border: 1px solid transparent;
    border-radius: 4px;
    padding: 12px 12px 12px 20px;
    max-width: 100%;
    width: 100%;

    p{
        line-height: 18px;
        margin: 0;
        font-size: 13px;
        color:#c92f54;
    }
    `;
const container = css`
    .ms-Label {
        color: #2a2a2a;
        font-weight: 600;
    }
    .continue {
        height: 48px;
        border-radius: 50px;
        background-color: #0078d4;
        cursor: pointer;
        font-size: 14px;
        font-family: Manrope, sans-serif;
        font-weight: 600;
        letter-spacing: -0.01em;
        transition: background-color 0.15s;
    }
    .continue:hover {
        background-color: #005a9e;
    }
    `;

function LoginForm(props) {
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();

    const [emailError, setEmailError] = useState(undefined);
    const [passwordError, setPasswordError] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(false);
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch()
    const history = useHistory();


    const handleSubmit = (event) => {
        
        let hasErrors = false;
        event.preventDefault();
        if (loading) return;
        if (!email) {
            setEmailError("Please provide your email")
            hasErrors = true;
        }
        if (!password) {
            setPasswordError("Please provide your password")
            hasErrors = true;
        }

        if (hasErrors) {
            return;
        }

        setLoading(true)
        setErrorMessage(false)
        var model = {
            Email: email,
            Password: password
        }
        axios.post(AUTH_CONFIG.API_URL + "/api/auth/login", model)
            .then((response) => {
                setAuthTokens({
                    accessToken: response.data.token,
                    refreshToken: response.data.refreshToken,
                    expires: response.data.expires
                });
                // navigate to the home route
                axios.get(AUTH_CONFIG.API_URL + "/api/Account/GetAppState")
                    .then((response) => {
                        logInCallback(response.data, history)
                    });
               // window.location.href = "/";
            })
            .catch((error) => {
                
                setErrorMessage(true)
                setLoading(false)
            });
        return false;
    }



    const logInCallback = (data, history) => {
        const store = window.store;
        dispatch(setAppState(data.clientViewModel));
        dispatch(updateUserProfile(data.userProfileModel));
        localStorage.setItem('user_type', data.userProfileModel.userType);

        const cookies = new Cookies();
        let t = cookies.get('theme');
        t = t ? t : "light";
        store.dispatch(toggleTheme(t));

        localStorage.setItem('last_facility', data.userProfileModel.lastFacilityId);

        const redirectLocation = localStorage.getItem("REDIRECT_ON_LOGIN") === 'undefined'
            ? null
            : JSON.parse(localStorage.getItem("REDIRECT_ON_LOGIN"));

        const { scheduleModule, formsModule, auditsModule } = data.clientViewModel.clientSettings;

        if (
            redirectLocation &&
            redirectLocation.indexOf('logout') === -1 &&
            redirectLocation.indexOf('forgot_password') === -1 &&
            redirectLocation.indexOf('reset_password') === -1
        ) {
            history.push(redirectLocation);
        } else if (data.userProfileModel.userType === "3") {
            if (isMobile) {
                history.push('/user/dashboard');
            } else {
                if (scheduleModule) {
                    history.push('/scheduler/my-schedule');
                } else if (formsModule) {
                    history.push('/user/forms');
                } else if (auditsModule) {
                    history.push('/admin/overview/audits');
                } else {
                    history.push('/scheduler/colleagues');
                }
            }
        } else {
            history.push('/scheduler/overview');
        }
    };


    const handleEmailChange = (event) => {
        setEmail(event.target.value);
        setEmailError(undefined)
    };

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
        setPasswordError(undefined)
    };
    return (
        <TwoSidedLayout width={432}>
            <div className="height100 flexcolumn width100 justifycenter" style={{ maxWidth:'432px', margin:'auto'} }>
                <h2 className="head-30 mb10" style={{fontSize:34}}>Sign in to your account</h2>
                <p className="d-p mb20 mt5" style={{fontSize:18}}>Welcome back-let's make today stress-free.</p>
                {errorMessage && <div className="my10" css={warning}>
                    <div className="displayflex flexcolumn">
                        <p className="label-large">The username or password is not correct.</p>
                        <p className="label-large">Did you <Link to="/forgot_password">forgot your password?</Link></p>
                    </div>
                </div>}
                <form onSubmit={handleSubmit} css={container}>
                    <div className="form-group">
                        <div className="mb20" css={error(emailError)}>
                            <TextField
                                errorMessage={emailError}
                                fullWidth
                                id="email"
                                placeholder="jdoe@company.com"
                                label="Email"
                                value={email}
                                onChange={handleEmailChange}
                                styles={{ fieldGroup: { height: '50px', border: 'none', boxShadow: 'rgba(0, 0, 0, 0.2) 0px 0px 0px 1px inset' }, field: { height: '48px', '::placeholder': { color: '#666666' } } }}
                            />
                        </div>
                        <div className="m-b-5" css={error(passwordError)}>
                            <TextField
                                styles={{ fieldGroup: { height: '50px', border: 'none', boxShadow: 'rgba(0, 0, 0, 0.2) 0px 0px 0px 1px inset' }, field: { height: '48px', '::placeholder': { color: '#666666' } } }}
                                id="password"
                                placeholder="Password"
                                label="Password"
                                type="password"
                                value={password}
                                canRevealPassword
                                onChange={handlePasswordChange}
                            />
                        </div>



                        <div className="displayflex " style={{ justifyContent: 'flex-end' }}>
                            <p style={{ fontSize: 13, margin: '5px 0 5px' }}><Link to="/forgot_password">Forgot password</Link></p>
                        </div>
                        <div>
                            <button type="submit" className="ms-Button ms-Button--primary mt15 continue width100" style={{ color: '#fff', border: 'none' }}>{!loading ? "Log in" : <Spinner size={SpinnerSize.small} />}</button>

                        </div>
                        <div className="flexcolumn aligncenter mt20">
                            <p className="d-p">By proceeding, you agree to the</p>
                            <div className="displayflex justifycenter">
                                <a id="" href="https://www.teamslyapp.com/terms" rel="noreferrer" target="_blank">
                                    <span className="d-p">Terms of Service</span>
                                </a>
                                <div class="mx5"> and </div>
                                <a id="" href="https://www.teamslyapp.com/privacy-policy" rel="noreferrer" target="_blank" >
                                    <span className="d-p">Privacy Policy</span>
                                </a>
                            </div>
                        </div>
                      
                    </div>
                </form>
            </div>
            <div style={{ padding: isMobile ? '24px 0px 40px 0px' : '24px 0px 10% 0px' }}>
                <div className="mt25 text-center displayflex justifycenter">
                    <p className="d-p">Don't have an account? <Link to="/signup">Sign Up</Link></p>
                </div>
            </div>
            
        </TwoSidedLayout>
    );
}

export default LoginForm;
